import { inject as p, provide as x, watchEffect as g, computed as h, ref as v } from "vue";
import { c as w, w as I, h as b } from "./focus-management-uTsAyIu4.js";
import { o as E } from "./dom-B5R6OWVp.js";
function L(e) {
  throw new Error("Unexpected object: " + e);
}
var C = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(C || {});
function O(e, l) {
  let n = l.resolveItems();
  if (n.length <= 0) return null;
  let i = l.resolveActiveIndex(), c = i ?? -1, r = (() => {
    switch (e.focus) {
      case 0:
        return n.findIndex((t) => !l.resolveDisabled(t));
      case 1: {
        let t = n.slice().reverse().findIndex((o, a, s) => c !== -1 && s.length - a - 1 >= c ? !1 : !l.resolveDisabled(o));
        return t === -1 ? t : n.length - 1 - t;
      }
      case 2:
        return n.findIndex((t, o) => o <= c ? !1 : !l.resolveDisabled(t));
      case 3: {
        let t = n.slice().reverse().findIndex((o) => !l.resolveDisabled(o));
        return t === -1 ? t : n.length - 1 - t;
      }
      case 4:
        return n.findIndex((t) => l.resolveId(t) === e.id);
      case 5:
        return null;
      default:
        L(e);
    }
  })();
  return r === -1 ? i : r;
}
let m = Symbol("Context");
var y = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(y || {});
function A() {
  return D() !== null;
}
function D() {
  return p(m, null);
}
function F(e) {
  x(m, e);
}
function d(e, l, n) {
  w.isServer || g((i) => {
    document.addEventListener(e, l, n), i(() => document.removeEventListener(e, l, n));
  });
}
function M(e, l, n = h(() => !0)) {
  function i(r, t) {
    if (!n.value || r.defaultPrevented) return;
    let o = t(r);
    if (o === null || !o.getRootNode().contains(o)) return;
    let a = function s(u) {
      return typeof u == "function" ? s(u()) : Array.isArray(u) || u instanceof Set ? u : [u];
    }(e);
    for (let s of a) {
      if (s === null) continue;
      let u = s instanceof HTMLElement ? s : E(s);
      if (u != null && u.contains(o) || r.composed && r.composedPath().includes(u)) return;
    }
    return !I(o, b.Loose) && o.tabIndex !== -1 && r.preventDefault(), l(r, o);
  }
  let c = v(null);
  d("mousedown", (r) => {
    var t, o;
    n.value && (c.value = ((o = (t = r.composedPath) == null ? void 0 : t.call(r)) == null ? void 0 : o[0]) || r.target);
  }, !0), d("click", (r) => {
    c.value && (i(r, () => c.value), c.value = null);
  }, !0), d("blur", (r) => i(r, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function f(e) {
  return [e.screenX, e.screenY];
}
function $() {
  let e = v([-1, -1]);
  return { wasMoved(l) {
    let n = f(l);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(l) {
    e.value = f(l);
  } };
}
export {
  A as C,
  C as a,
  F as c,
  y as l,
  D as p,
  $ as u,
  O as x,
  M as y
};
//# sourceMappingURL=use-tracked-pointer-D7o8jeoa.js.map
